<template lang="pug">
    div.image-editor-color-control
        div.image-editor-control__image-container
            fabric-image-control(:image="image" :filters="applyFilters" :watermark="watermark" @applying="applying = true" @applied="applying = false" ref="editor")
            div.image-editor-control__loader(v-show='applying')
                static-loader-control

        div.image-editor-color-control__item(v-for='filter in filters' :class="getItemClass(filter)")
            label {{ filter.label }}
            re-checkbox(v-if="filter.form == 'checkbox'" v-model='filterValues[filter.name]' @input='apply')
            range-slider-control(v-else v-model='filterValues[filter.name]' :min='filter.min' :max='filter.max' :step='filter.step' @change='apply')
</template>

<script>
import { fabric } from 'fabric'

const Filters = fabric.Image.filters

const DEFAULT_FILTERS = {
    brightness: 0,
    contrast: 0,
    saturate: 0,
    tint: 0,
    blur: 0,
    greyscale: false,
}

export default {
    name: 'image-editor-color-control',

    props: {
        image: {
            type: String,
            required: true,
        },
        watermark: {
            type: Object,
        },
    },

    data() {
        return {
            filterValues: null,
            applyFilters: null,
            applying: false,
        }
    },

    computed: {
        filters() {
            return [
                {
                    name: 'brightness',
                    label: 'Brightness',
                    min: -1,
                    max: 1,
                    step: 0.01,
                    f: v => new Filters.Brightness({ brightness: v }),
                },
                {
                    name: 'contrast',
                    label: 'Contrast',
                    min: -1,
                    max: 1,
                    step: 0.01,
                    f: v => new Filters.Contrast({ contrast: v }),
                },
                {
                    name: 'saturate',
                    label: 'Saturation',
                    min: 0,
                    max: 100,
                    step: 1,
                    f: v => new Filters.Saturation({ saturation: v / 100 * 10 }),
                },
                {
                    name: 'tint',
                    label: 'Tint',
                    min: 0,
                    max: 100,
                    step: 1,
                    f: v => new Filters.BlendColor({ color: 'white', mode: 'tint', alpha: v / 100 }),
                },
                {
                    name: 'blur',
                    label: 'Blur',
                    min: 0,
                    max: 100,
                    step: 1,
                    f: v => new Filters.Blur({ blur: v / 100 }),
                },
                {
                    name: 'greyscale',
                    label: 'Greyscale',
                    type: 'color',
                    form: 'checkbox',
                    f: () => new Filters.Grayscale(),
                },
            ]
        },
    },

    watch: {
        image: {
            handler() {
                this.reset()
            },
            immediate: true,
        },
    },

    methods: {
        reset() {
            this.filterValues = { ...DEFAULT_FILTERS }
            this.apply()
        },
        apply() {
            const filters = []

            for (let item in this.filterValues) {
                const filterValue = this.filterValues[item]

                if (filterValue) {
                    const filter = this.filters.find(filterItem => filterItem.name === item)
                    filters.push(filter.f(filterValue))
                }
            }

            this.applyFilters = filters
        },

        getModifiedImage() {
            return this.$refs.editor.getDataURL()
        },

        getItemClass(item) {
            return {
                'image-editor-color-control__item--checkbox': item.form == 'checkbox',
            }
        },
    },
}
</script>
